import React from 'react';

import { useChannelContext } from 'scbk-services/channel';
import { Channel, Modules, useConfig } from 'scbk-services/config';
import { useUserContext } from 'scbk-services/shared-context';

interface InitialRouteProps {
    navigate: React.ComponentType<{ replace: boolean; to: string }>;
}

const InitialRoute: React.FC<InitialRouteProps> = ({ navigate: Navigate }) => {
    const { getConfig } = useConfig();
    const { channel } = useChannelContext();
    const { isLoginUser } = useUserContext();

    const indexRoute = getConfig(Modules.COMMON).indexRoute;
    const loginRoute = getConfig(Modules.COMMON).loginRoute;

    let initialRoute = indexRoute;

    if (channel === Channel.IB) {
        initialRoute = isLoginUser() ? indexRoute : loginRoute;
    }

    return <Navigate replace to={initialRoute} />;
};

export { InitialRoute };
